var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal, { ModalSection, ModalHeader, ModalFooter, } from '@kiwicom/orbit-components/lib/Modal';
import Portal from '@kiwicom/orbit-components/lib/Portal';
var GenericModal = function (_a) {
    var _b = _a.renderInto, renderInto = _b === void 0 ? 'app' : _b, modalRef = _a.modalRef, children = _a.children, _c = _a.open, open = _c === void 0 ? false : _c, onClose = _a.onClose, _d = _a.size, size = _d === void 0 ? 'normal' : _d, headerTitle = _a.headerTitle, headerDescription = _a.headerDescription, headerContent = _a.headerContent, footerContent = _a.footerContent;
    if (!open) {
        return null;
    }
    return (_jsx(Portal, __assign({ renderInto: renderInto }, { children: _jsxs(Modal, __assign({ ref: modalRef, size: size, onClose: onClose }, { children: [(headerTitle || headerDescription || headerContent) && (_jsx(ModalHeader, __assign({ title: headerTitle, description: headerDescription }, { children: headerContent }))), children && (_jsx(ModalSection, __assign({ style: { padding: '0px' } }, { children: children }))), footerContent && _jsx(ModalFooter, { children: footerContent })] })) })));
};
export default GenericModal;
